<template>
  <div>
    <PrivacyCom title="BLUE RIDGE PRIVACY POLICY" class="pc-doc container"></PrivacyCom>
  </div>
</template>
<script>
import PrivacyCom from '../components/privacyCom.vue'
export default {
  data() {
    return {
      bannerFixed: false,
    }
  },
  components: {
    PrivacyCom,
  },
}
</script>
<style lang="scss">
@import '@/styles/public';
.pc-doc {
  padding-bottom: 80px;
  font-size: 20px;
  .title {
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    color: $theme-color;
    margin: 40px 0 30px;
  }
  .title-f{
    text-align: center;
    font-size: 20px;
    font-weight: normal;
  }
  .text {
    line-height: 1.5;
    color: #333;
    margin-bottom: 10px;
  }
  .bold {
    font-weight: bold;
  }
  .sub-title {
    /* color: $theme-color; */
    font-size: 20px;
    margin: 30px 0 10px;
    font-weight: bold;
    display: block;
  }
  .privacy-space {
    display: block;
    padding-left: 10px;
    margin-bottom: 10px;
  }
  .s-title {
    font-size: 18px;
    color: $theme-color;
    margin: 10px;
    // font-weight: bold;
  }
}
</style>